'use client';

// Root layout error boundary — must include <html><body> (Next 16 / React 19).

import { useEffect } from 'react';
import { designTokens } from '@roomtreatment/design';
import {
  EVENTS,
  captureException,
  safeErrorMessage,
  track,
} from '@/lib/analytics';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const message = safeErrorMessage(error);
    track(EVENTS.client_error, {
      message,
      source: 'global-error.tsx',
      digest: error.digest,
    });
    captureException(error, { source: 'global-error.tsx', digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased">
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.25rem',
            padding: '1.5rem',
            textAlign: 'center',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ maxWidth: '24rem' }}>
            <h1 style={{ fontSize: '18px', fontWeight: 600 }}>Something went wrong</h1>
            <p style={{ fontSize: '13px', lineHeight: 1.6, color: designTokens.inkFaint, marginTop: '0.5rem' }}>
              A critical error stopped the app. Try again or reload the page.
            </p>
          </div>
          <button
            type="button"
            onClick={reset}
            style={{
              border: `1px solid ${designTokens.hairline}`,
              borderRadius: '9999px',
              padding: '0.5rem 1rem',
              fontSize: '13px',
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
